const getNtmDiscount = (tableName: string, ltmColumnKey: string, ntmColumnKey: string) =>
  `=(${tableName}.${ntmColumnKey} / ${tableName}.${ltmColumnKey}) - 1`;

export default getNtmDiscount;
